export default {
  path: '/v5/leaderboards',
  name: 'V5_leaderboards',
  component: () => import('./LeaderboardsPage.vue'),
};
